import * as $ from 'jquery';
import {UIElement} from "./ui";
import '/modules/common/css/slim-panel.css';
import '/modules/common/css/slim-panel.responsive.css';
import '/modules/common/css/slim-panel.mobile.css';

/**
 * A slim panel that can be placed anywhere over the map
 * @extends UIElement
 */
class SlimPanel extends UIElement {

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Panel id
     * @param classes {string} HTML classes for the panel
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */
    constructor(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig) {
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.classes = classes;
        this.visible = false;
    }

    getClassName() {
        return "SlimPanel";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<div id="' + this.id + '" class="slim-panel-container ol-unselectable ol-control">'
                + '  <div aria-labelledby="' + this.id + '_title" role="dialog" aria-modal="true" class="slim-panel">'
                + '     <div class="slim-panel-container-header">'
                + '         <div class="slim-panel-title" id="' + this.id + '_title"></div>'
                + '         <button type="button" title="' + this.translator.translate('slimPanel.closer.name') + '" class="slim-panel-container-closer close-button"></button>'
                + '     </div>'
                + '     <div class="slim-panel-container-body"></div>'
                + '  </div>'
                + '</div>'
            );

            if (this.classes)
                this.uiElement.addClass(this.classes);

            $('.slim-panel-container-header .close-button', this.uiElement).click(() => {
                this.hide();
                this.logStat("HIDE");
            });
            this.uiElement.hide();
        }
        return this.uiElement;
    }

    /**
     * Set the title of the panel
     * @param titleText {string} The title
     */
    setTitle(titleText) {
        $('.slim-panel-title', this.getUIElement()).empty().html(titleText);
    }

    /**
     * Set the content of the panel
     * @param elements {jQuery} The content
     */
    setContent(elements) {
        $('.slim-panel-container-body', this.getUIElement()).empty()
            .append('<div class="top"></div>')
            .append(elements)
            .append('<div class="bottom"></div>');
    }

    getCode() {
        return this.id;
    }

    /**
     * Hide the panel
     */
    hide() {
        if (this.visible) {
            $('.slim-panel', this.getUIElement().fadeOut(600)).attr('tabIndex', "-1");
            this.visible = false;
            UIElement.openUIElements.pop();
        }
    }

    /**
     * Hide the panel
     */
    hideNoAnimation() {
        if (this.visible) {
            $('.slim-panel', this.getUIElement().hide()).attr('tabIndex', "-1");
            this.visible = false;
            UIElement.openUIElements.pop();
        }
    }

    /**
     * Show without defining a position
     */
    showNoPosition() {
        if (!this.visible) {
            $('.slim-panel', this.getUIElement().css({top: '', left: '', position: ''}).fadeIn(400))
            this.visible = true;
            UIElement.openUIElements.push(this);
        }
    }

    /**
     * Show in coordinates
     * @param top {number} pixels counting from top (integer)
     * @param left {number} pixels counting from left (integer)
     */
    show(top, left) {
        if (!this.visible) {
            if (!this.isSmallContainerWidth && !this.isSmallContainerHeight) {
                $('.slim-panel', this.getUIElement().css({
                    top: top,
                    left: left,
                    position: 'absolute'
                }).fadeIn(400)).attr('tabIndex', "1");
            } else {
                $('.slim-panel', this.getUIElement().css({
                    top: '',
                    left: '',
                    position: ''
                }).fadeIn(400)).attr('tabIndex', "1");
            }
            this.visible = true;
            UIElement.openUIElements.push(this);
        }
    }

    /**
     * Show panel on top position
     */
    showTop() {
        if (!this.visible) {
            $('.slim-panel', this.uiElement.css({top: '', left: '', position: ''})
                .removeClass('bottom')
                .addClass('top')
                .fadeIn(400)).attr('tabIndex', "1");
            this.visible = true;
            UIElement.openUIElements.push(this);
        }
    }

    /**
     * Show panel on bottom position
     */
    showBottom() {
        if (!this.visible) {
            $('.slim-panel', this.uiElement.css({top: '', left: '', position: ''})
                .addClass('bottom')
                .removeClass('top')
                .fadeIn(400)).attr('tabIndex', "1");
            this.visible = true;
            UIElement.openUIElements.push(this);
        }
    }

    isVisible() {
        return this.visible;
    }


    close() {
        this.hideNoAnimation();
    }
}

export {SlimPanel}